import React from "react";
import { Box, IconButton, Typography } from "@material-ui/core";
import { useTranslate } from "../../../../../Hooks";
import moment from "moment";

import useStyles from "./styles";
import { AEDIcon, SwitchHorizontal2Icon } from "../../../../../assets/icons";
import Download04 from "../../../../../assets/icons/Download04";
import { fillTemplate } from "../../../../../Helper";

function InvoiceDetails({ receipts = [] }) {
  const { translate } = useTranslate("AfterSalesClientProfileView");
  const styles = useStyles();

  if (receipts.length === 0) {
    return (
      <Box className={styles.emptyState}>
        <Typography>{translate("no-receipts")}</Typography>
      </Box>
    );
  }
  return (
    <Box className={styles.contentWrapper}>
      <Typography className={styles.title}>
        {translate("receipt-for-invoice")}
      </Typography>
      {receipts.map((receipt) => {
        const {
          dueOn,
          netAmount = 0,
          paymentModeName = "cash",
          createdOn,
          receiptId,
        } = receipt;
        return (
          <Box key={receiptId} className={styles.container}>
            <Typography className={styles.receiptDetails}>
              {fillTemplate(translate("receipt-details"), {
                date: moment(createdOn).year(),
                id: receiptId,
              })}
            </Typography>
            <Box className={styles.netAmount}>
              <Typography className={styles.receiptDetails} variant="body1">
                {netAmount}
              </Typography>
              <AEDIcon width={24} height={24} />
            </Box>
            <Box className={styles.paymentMode}>
              <SwitchHorizontal2Icon fill={"#000"} width={24} height={24} />
              <Typography className={styles.receiptDetails}>
                {paymentModeName}
              </Typography>
            </Box>
            <Typography className={styles.receiptDetails} variant="body1">
              {moment(dueOn).format("DD MMM , YYYY")}
            </Typography>
          </Box>
        );
      })}
    </Box>
  );
}

export default InvoiceDetails;
